import DealerBoxListPanel from "./dealerBoxListPanel.container"

export default DealerBoxListPanel
